import React, {useCallback, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import {strings} from "../../../strings";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from "@mui/material/Button";
import {sendMessage} from "../../../stores/message/thunk";
import {useDispatch, useSelector} from "react-redux";
import {Chip} from "@mui/material";
import {getUserById, getUsers, getUsersByLastName} from "../../../stores/user/userThunk";
import {initUserForm, selUsers} from "../../../stores/user/userSlice";
import _debounce from 'lodash/debounce';
import CircularProgress from '@mui/material/CircularProgress';


export default function Message() {

    const [ data, setData ] = useState({
        user:"", mobile:"", textMessage:""
    })

    const users = useSelector(selUsers)
    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch();

    function send(){
        const sms = {
            mobile: data.mobile,
            message: data.textMessage
        }

        const resetForm =()=>{
            setData({
                user:"", mobile:"", textMessage:""
            })
        }

        dispatch(sendMessage(sms,resetForm))
    }

    function setParametersMain(event){
        const { name, value } = event.target;
        setData({...data, [name]: value});
    }
    const debounceFn = useCallback(_debounce(handleDebounceFn, 1000), []);

    function onChangeSearchInput (event) {
        debounceFn(event.target.value);
    };

    async function handleDebounceFn(inputValue) {
        setLoading(true)
        await dispatch((getUsersByLastName(inputValue)))
        setLoading(false)
    }



    useEffect(() => {
            dispatch(getUsers())

    }, []);

    return (
        <Paper className="parentContentCreateProduct w-100">
            <div className="w-100">
                <Grid container spacing={2}
                      className="d-flex flex-wrap divParentContentBasicInformation">
                    <Grid item
                          xs={12} lg={4} xl={4}
                          className="d-flex justify-content-center align-items-center"
                    >
                        <Autocomplete
                            limitTags={2}
                            multiple
                            disableCloseOnSelect
                            className="w-100"
                            // value={users.filter(x => category.some(({id}) => x.id === id))}
                            getOptionLabel={(option) => option?.first_name + ' ' +  option?.last_name}
                            onChange={(event, newValue) => {
                                const newArray = newValue?.map((value) => value.mobile);
                                const newData =  newArray.toString();
                                setData({...data, [`mobile`]: newData});
                            }}
                            options={users}
                            loading={loading}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) => (
                                    <Chip
                                        label={option?.first_name + ' ' +  option?.last_name}
                                        {...getTagProps({index})}
                                    />
                                ))
                            }
                            renderInput={(params) =>
                                <>
                                    <TextField {...params}
                                               // error={errors?.category?.length > 0}
                                               label={'نام خانوادگی'}
                                               variant="outlined"
                                               type="text"
                                               placeholder="انتخاب دسته بندی"
                                               onChange={onChangeSearchInput}
                                               InputProps={{
                                                   ...params.InputProps,
                                                   endAdornment: (
                                                       <React.Fragment>
                                                           {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                           {params.InputProps.endAdornment}
                                                       </React.Fragment>
                                                   ),
                                               }}
                                    />
                                </>
                            }
                        />
                    </Grid>
                    <Grid item
                          xs={12} lg={4} xl={4}
                          className="d-flex justify-content-center align-items-center"
                    >
                        <TextField
                            label={'موبایل'}
                            variant="outlined"
                            name={'mobile'}
                            value={data.mobile}
                            // error={errors.mobile}
                            className={`w-100`}
                            onChange={setParametersMain}
                        />
                    </Grid>
                    {/*<Grid item*/}
                    {/*      xs={12} lg={12} xl={12}*/}
                    {/*      className="d-flex justify-content-center align-items-center"*/}
                    {/*>*/}
                    {/*    <Autocomplete*/}
                    {/*        className={`w-100`}*/}
                    {/*        // value={provinces.find(data=> data.value === user?.gender)}*/}
                    {/*        options={strings.messages}*/}
                    {/*        getOptionLabel={(option) => option.text ? option.text : ''}*/}
                    {/*        onChange={(event, value) => {*/}
                    {/*            setData({...data, [`textMessage`]: value?.text});*/}
                    {/*        }}*/}
                    {/*        renderInput={(params) => (*/}
                    {/*            <TextField {...params}*/}
                    {/*                       variant="outlined"*/}
                    {/*                       className={`w-100`}*/}
                    {/*                       label="پیام های آماده"/>*/}
                    {/*        )}*/}
                    {/*    />*/}
                    {/*</Grid>*/}

                    <Grid item
                          xs={12} lg={12} xl={12}
                          className="d-flex justify-content-center align-items-center"
                    >
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={15}
                            placeholder=""
                            style={{ width: "100%" }}
                            name="textMessage"
                            value={data.textMessage}
                            onChange={setParametersMain}
                        />
                    </Grid>
                    <Button
                        variant="contained"
                        onClick={ send }
                        className="continuationButtonCreateProduct mr-3 mt-5"
                    >
                        ایجاد
                    </Button>
                </Grid>
            </div>
        </Paper>
    );

}
